import { render, staticRenderFns } from "./DashboardDetailDialog.vue?vue&type=template&id=66dc87c0&scoped=true"
import script from "./DashboardDetailDialog.vue?vue&type=script&lang=js"
export * from "./DashboardDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DashboardDetailDialog.vue?vue&type=style&index=0&id=66dc87c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc87c0",
  null
  
)

export default component.exports